import { editBond, flipBondDirection, clearChirality, neighborsList } from '@moleculeone/draw';

import { updateMols, updateState } from '../../../state';
import { TOGGLE_BOND_DASHED_MODE, MOL_MOUSE_EVENT, MOUSE_DOWN, MOUSE_MOVE, MOUSE_UP } from '../../../../etc/constants';
import { DASHED, WEDGE } from '../../molecule-object.actions';

export default function (modeType) {
  const initial = {
    type: modeType,
    data: null,
  };

  function toggleChirality(mol, bondIdx) {
    const bond = mol.bonds[bondIdx];
    const type = modeType === TOGGLE_BOND_DASHED_MODE ? DASHED : WEDGE;

    let newMol = mol;
    if (bond.type === type) {
      newMol = flipBondDirection(newMol, bondIdx);

      if (Number(bond.start) > Number(bond.end)) {
        newMol = clearChirality(newMol, bondIdx);
      }
    } else {
      const neighborsListStart = neighborsList(newMol, bond.start);
      const neighborsListEnd = neighborsList(newMol, bond.end);

      newMol = editBond(newMol, bondIdx, 1, type);

      if (neighborsListStart.length < neighborsListEnd.length) {
        newMol = flipBondDirection(newMol, bondIdx);
      } else if (Number(bond.start) > Number(bond.end)) {
        newMol = flipBondDirection(newMol, bondIdx);
      }
    }

    return newMol;
  }

  function effect(state, action) {
    if (action.type !== MOL_MOUSE_EVENT) {
      return {};
    }

    return baseEffect(state.mols, state.mode, action.event, state.mouse.molIndex);
  }

  function baseEffect(mols, mode, event, molIndex) {
    if (event.type === MOUSE_MOVE) {
      return {};
    }

    const data = mode.data;
    let newMol = mols[molIndex];

    if (event.type === MOUSE_DOWN && data != null) {
      //
    } else if (event.type === MOUSE_UP && data == null) {
      if (event.atom) {
        //
      } else if (event.bond) {
        newMol = toggleChirality(newMol, event.idx);
      } else if (event.empty) {
        //
      }
    } else if (event.type === MOUSE_DOWN && data == null) {
      //
    } else if (event.type === MOUSE_UP && data != null) {
      //
    }

    return { mols: updateMols(mols, newMol, molIndex) };
  }

  function preview(state) {
    const { lastMove, molIndex } = state.mouse;
    if (lastMove != null && lastMove.bond) {
      const mouseDownEvent = updateState(lastMove, { type: MOUSE_DOWN });
      const mouseDownPreviewState = baseEffect(state.mols, state.mode, mouseDownEvent, molIndex);
      const mouseUpEvent = updateState(lastMove, { type: MOUSE_UP });
      const previewState = baseEffect(mouseDownPreviewState.mols, state.mode, mouseUpEvent, molIndex);
      const previewMol = previewState.mols[molIndex];

      if (previewMol != null && previewMol !== state.mols[molIndex]) {
        const editedBonds = {};
        for (const [key, bond] of Object.entries(previewMol.bonds)) {
          if (
            bond.type !== state.mols[molIndex].bonds[key].type ||
            bond.start !== state.mols[molIndex].bonds[key].start
          ) {
            editedBonds[key] = { ...bond, preview: true };
          }
        }

        return updateState(previewMol, {
          bonds: updateState(previewMol.bonds, editedBonds),
        });
      }
    } else if (lastMove != null && lastMove.atom) {
      return state.mol;
    }

    return null;
  }

  function cleanup(mode) {
    return mode;
  }

  return {
    trait: {
      type: modeType,
      initial,
      effect,
      preview,
      cleanup,
    },
  };
}
